import MarketCard from './MarketCard';

export default MarketCard;
